import React from 'react';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';
import GradientButton from 'src/components/elements/GradientButton';

import metrics from 'src/utility/metrics';

import { APP_URL, S3_IMAGES_URL } from '../../constants';

import styles from './DownloadBlock.scss';

const DownloadBlock = () => {
  const { isDesktop } = useLayoutContext();

  const downloadClick = (event) => {
    event.preventDefault();
    metrics('SOLAR_LANDING_INSTALL_BUTTON', { trigger: 'download block' });
    window.open(APP_URL);
  };

  return (
    <div className={styles.downloadBlock}>
      {isDesktop && (
        <div className={styles.qrCodeWrapper}>
          <img
            className={styles.qrCode}
            src={`${S3_IMAGES_URL}main_screen/qr_code.svg`}
            alt="qr-code"
          />
        </div>
      )}

      <FadeIn className={styles.title}>
        {isDesktop ? (
          <>
            <span className={styles.titleThin}>Download</span> app
          </>
        ) : (
          <>
            <span className={styles.titleThin}>Begin your journey</span> with Solartrip
          </>
        )}
      </FadeIn>

      {!isDesktop && (
        <FadeIn className={styles.downloadButton} delay={1}>
          <GradientButton darkGradient={true} onClick={downloadClick}>
            Download app
          </GradientButton>
        </FadeIn>
      )}
    </div>
  );
};

export default DownloadBlock;
